export default {
  apiContactFormPostinId: 'ad4308f5-7d54-481a-9f70-3fbe0f69a49b',
  name: 'Name*',
  surname: 'Surname*',
  phone: 'Telephone*',
  company: 'Company*',
  message: 'Messagge*',
  sendRequest: 'Send Request',
  termsExtLabel:
    'In accordance with and for the purposes of Reg. EU 2016/679 - GDPR: I consent to the processing of my personal data as per the <a href="{url}" target="_blank">privacy policy</a>.',
  termsError: 'Accept the terms and conditions',
  successPageTitle: 'Request sent successfully',
  successPageText:
    'Thank you for contacting us. We will get back to you as soon as possible.',
  failurePageTitle: 'Error sending request',
  failurePageText:
    'An error occurred while sending the request. Please try again later.',
  formIntro: '<b>Do you want to start</b> a project?',
  formText:
    'We are happy to meet you! Fill out the form below, and we will get back to you shortly.',
  policyChat:
    'ChatLGBTQ+ is an AI-based virtual assistant by SUNTIMES. Responses are automatically generated and may contain inaccuracies.',
  chatPlaceholder: 'What would you like to know?',
  // Trasparenza AI Act art. 50: dichiarazione obbligatoria al primo contatto.
  // Volutamente hardcoded e non gestita da DatoCMS per non poter essere rimossa.
  chatAiLabel: 'AI Assistant',
  chatAiDisclaimer:
    'You are interacting with an AI-based virtual assistant. Responses are automatically generated and may contain inaccuracies.',
}
